import respond from './utilities/respond'
import generateActionCreators from './utilities/generateActionCreators'
import at from '../../actionTypes'
import setVoteForFeature from '../../../dataservices/setVoteForFeature'

const itemActions = {
	itemFeatureVote: dispatch => (featureType, vote, prevVote) => {
		dispatch(respond(at.ITEM_FEATURE_VOTE, { featureType, vote, prevVote }))
	},

	itemFeatureVoteSave: dispatch => (uid, voteType, itemKey, featureType) => {
		dispatch(respond(at.ITEM_FEATURE_VOTE_SAVE_BEGIN, { uid, voteType, itemKey, featureType }))
		setVoteForFeature(uid, voteType, itemKey, featureType).then(() => {
			dispatch(itemActions.itemFeatureVoteSaveSuccess(uid, voteType, itemKey, featureType))
		}).catch((error) => {
			dispatch(itemActions.itemFeatureVoteSaveFail(error, uid, voteType, itemKey, featureType))
		})
	},

	itemFeatureVoteSaveSuccess: (uid, voteType, itemKey, featureType) => respond(at.ITEM_FEATURE_VOTE_SAVE_SUCCESS, { uid, voteType, itemKey, featureType }),
	itemFeatureVoteSaveFail: (error, uid, voteType, itemKey, featureType) => respond(at.ITEM_FEATURE_VOTE_SAVE_FAIL, { error, uid, voteType, itemKey, featureType }),

	...generateActionCreators(at.jerseyNameSuggestions, 'jerseyNameSuggestions')
}

export default itemActions



// WEBPACK FOOTER //
// ./src/redux/actionCreators/old_actions/itemActions.js